import script from "./videocallheader.vue?vue&type=script&setup=true&lang=js"
export * from "./videocallheader.vue?vue&type=script&setup=true&lang=js"

import "./videocallheader.vue?vue&type=style&index=0&id=0b9a9fd0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b9a9fd0"]])

export default __exports__